import React from 'react'

function LeftPanel() {
  return (
    <div></div>
  )
}

export default LeftPanel